// Indian States and Cities Database
export const INDIAN_STATES = [
  "Andhra Pradesh", "Arunachal Pradesh", "Assam", "Bihar", "Chhattisgarh",
  "Goa", "Gujarat", "Haryana", "Himachal Pradesh", "Jharkhand", "Karnataka",
  "Kerala", "Madhya Pradesh", "Maharashtra", "Manipur", "Meghalaya", "Mizoram",
  "Nagaland", "Odisha", "Punjab", "Rajasthan", "Sikkim", "Tamil Nadu",
  "Telangana", "Tripura", "Uttar Pradesh", "Uttarakhand", "West Bengal",
  "Andaman and Nicobar Islands", "Chandigarh", "Dadra and Nagar Haveli",
  "Daman and Diu", "Delhi", "Jammu and Kashmir", "Ladakh", "Lakshadweep", "Puducherry"
];

export const INDIAN_CITIES = {
  "Andhra Pradesh": ["Visakhapatnam", "Vijayawada", "Guntur", "Nellore", "Kurnool", "Rajahmundry", "Tirupati", "Kakinada", "Kadapa", "Anantapur"],
  "Arunachal Pradesh": ["Itanagar", "Naharlagun", "Pasighat", "Namsai", "Tezu"],
  "Assam": ["Guwahati", "Silchar", "Dibrugarh", "Jorhat", "Nagaon", "Tinsukia", "Tezpur"],
  "Bihar": ["Patna", "Gaya", "Bhagalpur", "Muzaffarpur", "Darbhanga", "Purnia", "Arrah", "Begusarai"],
  "Chhattisgarh": ["Raipur", "Bhilai", "Bilaspur", "Korba", "Durg", "Rajnandgaon"],
  "Goa": ["Panaji", "Margao", "Vasco da Gama", "Mapusa", "Ponda"],
  "Gujarat": ["Ahmedabad", "Surat", "Vadodara", "Rajkot", "Bhavnagar", "Jamnagar", "Gandhinagar", "Junagadh", "Anand", "Nadiad"],
  "Haryana": ["Faridabad", "Gurgaon", "Panipat", "Ambala", "Yamunanagar", "Rohtak", "Hisar", "Karnal", "Sonipat"],
  "Himachal Pradesh": ["Shimla", "Mandi", "Dharamshala", "Solan", "Kullu", "Manali", "Palampur"],
  "Jharkhand": ["Ranchi", "Jamshedpur", "Dhanbad", "Bokaro", "Deoghar", "Hazaribagh"],
  "Karnataka": ["Bangalore", "Mysore", "Hubli", "Mangalore", "Belgaum", "Gulbarga", "Davangere", "Bellary", "Shimoga"],
  "Kerala": ["Thiruvananthapuram", "Kochi", "Kozhikode", "Thrissur", "Kollam", "Palakkad", "Alappuzha", "Kannur"],
  "Madhya Pradesh": ["Bhopal", "Indore", "Jabalpur", "Gwalior", "Ujjain", "Sagar", "Dewas", "Satna", "Ratlam"],
  "Maharashtra": ["Mumbai", "Pune", "Nagpur", "Thane", "Nashik", "Aurangabad", "Solapur", "Kolhapur", "Amravati", "Navi Mumbai"],
  "Manipur": ["Imphal", "Thoubal", "Bishnupur", "Churachandpur"],
  "Meghalaya": ["Shillong", "Tura", "Jowai", "Nongstoin"],
  "Mizoram": ["Aizawl", "Lunglei", "Champhai", "Serchhip"],
  "Nagaland": ["Kohima", "Dimapur", "Mokokchung", "Tuensang"],
  "Odisha": ["Bhubaneswar", "Cuttack", "Rourkela", "Berhampur", "Sambalpur", "Puri"],
  "Punjab": ["Ludhiana", "Amritsar", "Jalandhar", "Patiala", "Bathinda", "Mohali", "Pathankot"],
  "Rajasthan": ["Jaipur", "Jodhpur", "Udaipur", "Kota", "Bikaner", "Ajmer", "Bhilwara", "Alwar"],
  "Sikkim": ["Gangtok", "Namchi", "Gyalshing", "Mangan"],
  "Tamil Nadu": ["Chennai", "Coimbatore", "Madurai", "Tiruchirappalli", "Salem", "Tirunelveli", "Vellore", "Erode"],
  "Telangana": ["Hyderabad", "Warangal", "Nizamabad", "Karimnagar", "Khammam", "Ramagundam"],
  "Tripura": ["Agartala", "Udaipur", "Dharmanagar", "Kailashahar"],
  "Uttar Pradesh": ["Lucknow", "Kanpur", "Ghaziabad", "Agra", "Varanasi", "Meerut", "Allahabad", "Bareilly", "Aligarh", "Noida"],
  "Uttarakhand": ["Dehradun", "Haridwar", "Roorkee", "Haldwani", "Rudrapur", "Kashipur"],
  "West Bengal": ["Kolkata", "Howrah", "Durgapur", "Asansol", "Siliguri", "Bardhaman", "Malda"],
  "Delhi": ["New Delhi", "Delhi", "Dwarka", "Rohini", "Saket", "Karol Bagh", "Connaught Place"],
  "Chandigarh": ["Chandigarh"],
  "Puducherry": ["Puducherry", "Karaikal", "Mahe", "Yanam"]
};

// All cities flat list for global search
export const ALL_CITIES = Object.values(INDIAN_CITIES).flat();

// Common Indian Companies
export const INDIAN_COMPANIES = [
  // IT/Software
  "Tata Consultancy Services (TCS)", "Infosys", "Wipro", "HCL Technologies", "Tech Mahindra",
  "Cognizant", "Accenture India", "IBM India", "Capgemini India", "L&T Infotech",
  "Mindtree", "Mphasis", "Persistent Systems", "Cyient", "Hexaware Technologies",
  "NIIT Technologies", "Zensar Technologies", "Coforge", "Birlasoft", "Sonata Software",
  
  // Product Companies
  "Google India", "Microsoft India", "Amazon India", "Flipkart", "Paytm",
  "Ola", "Swiggy", "Zomato", "Byju's", "PhonePe", "Razorpay", "Freshworks",
  "Zoho", "InMobi", "PolicyBazaar", "Nykaa", "CRED", "Meesho", "Zerodha",
  
  // Banking/Finance
  "State Bank of India", "HDFC Bank", "ICICI Bank", "Axis Bank", "Kotak Mahindra Bank",
  "Punjab National Bank", "Bank of Baroda", "Yes Bank", "IndusInd Bank", "Federal Bank",
  "HDFC Ltd", "Bajaj Finance", "LIC", "SBI Life", "ICICI Prudential",
  
  // Manufacturing/Conglomerate
  "Reliance Industries", "Tata Group", "Mahindra & Mahindra", "Larsen & Toubro",
  "Adani Group", "Aditya Birla Group", "JSW Group", "Vedanta", "Jindal Steel",
  "Godrej Group", "ITC Limited", "Hindustan Unilever", "Nestle India", "Britannia",
  
  // Telecom
  "Bharti Airtel", "Reliance Jio", "Vodafone Idea", "BSNL", "MTNL",
  
  // Automobile
  "Maruti Suzuki", "Tata Motors", "Hyundai India", "Honda Cars India", "Toyota India",
  "Mahindra Automotive", "Hero MotoCorp", "Bajaj Auto", "TVS Motor", "Royal Enfield",
  
  // Pharma/Healthcare
  "Sun Pharma", "Cipla", "Dr. Reddy's", "Lupin", "Aurobindo Pharma",
  "Biocon", "Cadila Healthcare", "Glenmark", "Torrent Pharma", "Divi's Labs",
  "Apollo Hospitals", "Fortis Healthcare", "Max Healthcare", "Manipal Hospitals",
  
  // Consulting
  "McKinsey & Company", "Boston Consulting Group", "Bain & Company", "Deloitte India",
  "PwC India", "EY India", "KPMG India", "Grant Thornton",
  
  // E-commerce/Retail
  "Amazon India", "Flipkart", "Myntra", "Reliance Retail", "DMart",
  "Big Bazaar", "Shoppers Stop", "Lifestyle", "Westside", "Croma",
  
  // Others
  "Infosys BPO", "Genpact", "WNS", "EXL Service", "Firstsource",
  "Concentrix", "Teleperformance", "Sutherland", "HGS", "iGate"
];

// Indian Universities
export const INDIAN_UNIVERSITIES = [
  // Central Universities
  "University of Delhi", "Jawaharlal Nehru University (JNU)", "Banaras Hindu University (BHU)",
  "Aligarh Muslim University (AMU)", "University of Hyderabad", "Jamia Millia Islamia",
  "Central University of Karnataka", "Central University of Kerala", "Central University of Punjab",
  
  // IITs
  "Indian Institute of Technology Bombay (IIT Bombay)", "Indian Institute of Technology Delhi (IIT Delhi)",
  "Indian Institute of Technology Madras (IIT Madras)", "Indian Institute of Technology Kanpur (IIT Kanpur)",
  "Indian Institute of Technology Kharagpur (IIT Kharagpur)", "Indian Institute of Technology Roorkee (IIT Roorkee)",
  "Indian Institute of Technology Guwahati (IIT Guwahati)", "Indian Institute of Technology Hyderabad (IIT Hyderabad)",
  "Indian Institute of Technology Indore (IIT Indore)", "Indian Institute of Technology (BHU) Varanasi",
  
  // IIMs
  "Indian Institute of Management Ahmedabad (IIM-A)", "Indian Institute of Management Bangalore (IIM-B)",
  "Indian Institute of Management Calcutta (IIM-C)", "Indian Institute of Management Lucknow (IIM-L)",
  "Indian Institute of Management Kozhikode (IIM-K)", "Indian Institute of Management Indore (IIM-I)",
  
  // NITs
  "National Institute of Technology Trichy (NIT Trichy)", "National Institute of Technology Surathkal (NIT Karnataka)",
  "National Institute of Technology Warangal (NIT Warangal)", "National Institute of Technology Calicut",
  "National Institute of Technology Rourkela", "National Institute of Technology Kurukshetra",
  
  // State Universities
  "Anna University", "Osmania University", "University of Mumbai", "University of Pune",
  "University of Calcutta", "University of Madras", "Gujarat University", "Rajasthan University",
  "Bangalore University", "Punjab University", "JNTU Hyderabad", "JNTU Kakinada",
  "Andhra University", "Sri Venkateswara University", "Kakatiya University",
  
  // Private Universities
  "Birla Institute of Technology and Science (BITS Pilani)", "Vellore Institute of Technology (VIT)",
  "Manipal Academy of Higher Education", "SRM Institute of Science and Technology",
  "Amity University", "Lovely Professional University (LPU)", "Shiv Nadar University",
  "Ashoka University", "O.P. Jindal Global University", "Symbiosis International University",
  "Christ University", "KIIT University", "Chitkara University", "Chandigarh University",
  
  // Medical Universities
  "All India Institute of Medical Sciences (AIIMS)", "Christian Medical College Vellore",
  "JIPMER Puducherry", "Armed Forces Medical College (AFMC)", "Maulana Azad Medical College",
  
  // Law Universities
  "National Law School of India University (NLSIU)", "National Law University Delhi",
  "NALSAR University of Law", "National Law Institute University Bhopal",
  
  // Deemed Universities
  "Indian Statistical Institute (ISI)", "Tata Institute of Social Sciences (TISS)",
  "Indian Institute of Science (IISc)", "Tata Institute of Fundamental Research (TIFR)"
];

// Indian Colleges (Top colleges across fields)
export const INDIAN_COLLEGES = [
  // Engineering Colleges
  "College of Engineering, Pune (COEP)", "Jadavpur University", "PSG College of Technology",
  "BMS College of Engineering", "RV College of Engineering", "PES University",
  "NSIT Delhi", "DTU Delhi", "IIIT Hyderabad", "IIIT Delhi", "IIIT Bangalore",
  "Netaji Subhas University of Technology", "Army Institute of Technology",
  "MIT Manipal", "SSN College of Engineering", "Thiagarajar College of Engineering",
  
  // Commerce/Business Colleges
  "Shri Ram College of Commerce (SRCC)", "Lady Shri Ram College", "St. Xavier's College Mumbai",
  "St. Xavier's College Kolkata", "Loyola College Chennai", "Presidency College Chennai",
  "Hindu College Delhi", "Hansraj College Delhi", "Kirori Mal College", "Ramjas College",
  "St. Stephen's College", "Miranda House", "Narsee Monjee College of Commerce",
  
  // Arts/Science Colleges
  "Fergusson College Pune", "St. Joseph's College Bangalore", "Presidency University Kolkata",
  "Madras Christian College", "Wilson College Mumbai", "Elphinstone College Mumbai",
  "DAV College Chandigarh", "Government College Chandigarh", "Panjab University Colleges",
  
  // Medical Colleges
  "Grant Medical College Mumbai", "Seth GS Medical College", "KEM Hospital and College",
  "Madras Medical College", "Stanley Medical College", "Bangalore Medical College",
  "St. John's Medical College", "Kasturba Medical College Manipal", "JSS Medical College",
  
  // Law Colleges
  "Government Law College Mumbai", "ILS Law College Pune", "Symbiosis Law School",
  "Army Law College Pune", "Faculty of Law Delhi University", "Campus Law Centre Delhi",
  
  // Architecture Colleges
  "School of Planning and Architecture (SPA) Delhi", "SPA Bhopal", "CEPT University",
  "JJ School of Architecture", "Chandigarh College of Architecture",
  
  // Design Colleges
  "National Institute of Design (NID)", "National Institute of Fashion Technology (NIFT)",
  "Srishti Institute of Art Design and Technology", "Pearl Academy",
  
  // Hotel Management
  "Institute of Hotel Management Delhi", "IHM Mumbai", "IHM Bangalore",
  "Welcomgroup Graduate School of Hotel Administration", "Christ University Hotel Management"
];

// Search function for autocomplete
export const searchInList = (list, query, limit = 10) => {
  if (!query || query.length < 2) return [];
  const lowerQuery = query.toLowerCase();
  return list
    .filter(item => item.toLowerCase().includes(lowerQuery))
    .slice(0, limit);
};

// Get cities by state
export const getCitiesByState = (state) => {
  return INDIAN_CITIES[state] || [];
};
